function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.799 17.678l6.718 6.717a1.5 1.5 0 01-2.122 2.122l-6.717-6.718-6.718 6.718a1.5 1.5 0 01-2.121-2.122l6.717-6.717L8.84 10.96A1.5 1.5 0 0110.96 8.84l6.718 6.717 6.717-6.717a1.5 1.5 0 112.122 2.121l-6.718 6.718z",
  fill: "#A9ADB4",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props), _ref);
};

export default SvgComponent;